import React, { useState } from 'react'
import logoImage from '../logo.png';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';


export default function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    return (
        <header className="fixed top-0 left-0 right-0 backdrop-blur-xl border-slate-200 z-50 shadow-sm bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    <Link to={'/'}>
                        <img src={logoImage} alt="Invs fintech" className="h-14" />
                    </Link>

                    <nav className="hidden lg:flex items-center gap-10">
                        <Link to={'/'} className="text-slate-700 hover:text-[#1e3a8a] transition-all text-base font-medium">Home</Link>
                        <Link to={'/aboutus'} className="text-slate-700 hover:text-[#1e3a8a] transition-all text-base font-medium">About Us</Link>
                        <Link to={'/product'} className="text-slate-700 hover:text-[#1e3a8a] transition-all text-base font-medium">Products</Link>
                        <Link to={'/contact'} className="text-slate-700 hover:text-[#1e3a8a] transition-all text-base font-medium">Contact Us</Link>

                    </nav>

                    <div className="hidden lg:flex items-center gap-4">

                        {/* <button className="bg-gradient-to-r from-[#1e3a8a] to-[#0ea5e9] text-white px-6 py-2.5 rounded-lg hover:shadow-lg hover:scale-105 transition-all border-white font-semibold">
                            <CallIcon /> Book A Demo
                        </button> */}
                        <Link to={'/contact'}>
                            <button className="text-white px-5 py-2.5 bg-[#00bd86] rounded-lg hover:shadow-lg hover:scale-105 transition-all font-semibold">
                                Enquiry-Now  <ArrowOutwardIcon />
                            </button>
                        </Link>
                    </div>

                    <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden">
                        {/* {mobileMenuOpen ? <p>open</p> : <p>cloded</p>} */}
                        { mobileMenuOpen ? <CloseIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
                    </button>
                </div>
            </div>

            {mobileMenuOpen && (
                <div className="lg:hidden bg-white border-t border-slate-200 px-6 py-4">
                    <nav className="flex flex-col gap-4">
                        <Link to={'/'} className="text-slate-700 hover:text-[#1e3a8a] py-2">Home</Link>
                        <Link to={'/aboutus'} className="text-slate-700 hover:text-[#1e3a8a] py-2">About Us</Link>
                        <Link to={'/product'} className="text-slate-700 hover:text-[#1e3a8a] py-2">Products</Link>
                        <Link to={'/contact'} className="text-slate-700 hover:text-[#1e3a8a] py-2">Contact Us</Link>
                        {/* <div className="flex flex-col gap-2 pt-4 border-t border-slate-200">
                            <button className="text-slate-700 px-5 py-2.5 text-left">Book a Demo</button>
                            <button className="bg-gradient-to-r from-[#1e3a8a] to-[#0ea5e9] text-white px-6 py-2.5 rounded-full">
                                Get Started
                            </button>
                        </div> */}
                    </nav>
                </div>
            )}
        </header>
    )
}
